import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";

// Context Providers (für zukünftige Features vorbereitet)
import { AuthProvider } from "@/contexts/AuthContext";
import { PaymentProvider } from "@/contexts/PaymentContext";
import { FoerderantragProvider } from "@/contexts/FoerderantragContext";
import { InfoDialogProvider } from "@/contexts/InfoDialogContext";

// Neue Seiten
import HomePage from "@/pages/HomePage";
import WasWirTunPage from "@/pages/WasWirTunPage";
import FoerdernPage from "@/pages/FoerdernPage";
import SelbsthilfePage from "@/pages/SelbsthilfePage";
import WissenPage from "@/pages/WissenPage";
import TransparenzPage from "@/pages/TransparenzPage";
import UeberUnsPage from "@/pages/UeberUnsPage";
import FoerdererWerdenPage from "@/pages/FoerdererWerdenPage";
import UnterstuetzungAnfragenPage from "@/pages/UnterstuetzungAnfragenPage";

// Bestehende Seiten
import KontaktPage from "@/pages/KontaktPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";

function App() {
  return (
    <AuthProvider>
      <PaymentProvider>
        <FoerderantragProvider>
          <InfoDialogProvider>
            <BrowserRouter>
              <Layout>
                <Routes>
                  {/* Hauptnavigation */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/was-wir-tun" element={<WasWirTunPage />} />
                  <Route path="/foerdern" element={<FoerdernPage />} />
                  <Route path="/selbsthilfe" element={<SelbsthilfePage />} />
                  <Route path="/wissen" element={<WissenPage />} />
                  <Route path="/transparenz" element={<TransparenzPage />} />
                  <Route path="/ueber-uns" element={<UeberUnsPage />} />
                  <Route path="/foerderer-werden" element={<FoerdererWerdenPage />} />
                  <Route path="/unterstuetzung-anfragen" element={<UnterstuetzungAnfragenPage />} />
                  <Route path="/foerderung-anfragen" element={<Navigate to="/unterstuetzung-anfragen" replace />} />
                  
                  {/* Rechtliche Seiten */}
                  <Route path="/kontakt" element={<KontaktPage />} />
                  <Route path="/impressum" element={<ImpressumPage />} />
                  <Route path="/datenschutz" element={<DatenschutzPage />} />
                  
                  {/* Redirects für alte URLs */}
                  <Route path="/angebote" element={<Navigate to="/foerdern" replace />} />
                  <Route path="/preise" element={<Navigate to="/foerdern" replace />} />
                  <Route path="/termine" element={<Navigate to="/kontakt" replace />} />
                  <Route path="/foerderer" element={<Navigate to="/foerderer-werden" replace />} />
                  <Route path="/spenden" element={<Navigate to="/foerderer-werden" replace />} />
                  <Route path="/beratung" element={<Navigate to="/kontakt" replace />} />
                  
                  {/* Fallback */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </BrowserRouter>
          </InfoDialogProvider>
        </FoerderantragProvider>
      </PaymentProvider>
    </AuthProvider>
  );
}

export default App;
